import React, { useEffect, useMemo, useState } from 'react';
import GPTLanguageSelect from '../GPTLanguageSelect';
import type { DateValueType, GPTSelectType } from '../../types';
import './index.scss';
import TimePicker from '../DateSelect/TimePicker';
import { commonBackInfo } from '../../utils';
import { defaultGptRangePickerValue } from '../../constants/date';
import { formatTimeToServer } from '@op/utils/time';

const dateTypeMap: any = {
  daily: '1',
  '7days': '2',
  '30days': '3',
};
const timePickerTypes = ['', 'date', '7days', '30days'];
const dateToMap = {
  Day: 'date',
  Week: '7days',
  Month: '30days',
};

export default function GPTSelect({
  lang,
  onChange,
  defaultKey,
  filterOptions,
  filterValue,
  defaultValue,
  rangePickerDefaultValue = defaultGptRangePickerValue,
  showShortcut = false,
  ...otherProps
}: GPTSelectType) {
  const [languageKey, setLanguageKey] = useState('1');
  const [languageMap, setLanguageMap] = useState<any>({});
  const [timePickerOptions, setTimePickerOptions] = useState<any>(['date']);
  const [languageChoose, setLanguageChoose] = useState('');
  const [kind, setKind] = useState('');

  const [timeValue, setTimeValue] = useState<Array<string>>([]);
  const [dateType, setDateType] = useState('date');

  const languageFilterOptions = useMemo(() => {
    const result = languageMap?.[languageKey];
    return result ? result : [];
  }, [languageKey, languageMap]);

  const changeDateType = (_value: string, originValue?: string) => {
    const realDateType =
      (originValue === 'date' ? _value : originValue) || 'date';
    if (dateType !== originValue) {
      setDateType(originValue || 'date');
      let languageKey = dateTypeMap[realDateType];
      setLanguageKey(languageKey);
      setLanguageChoose(languageMap?.[languageKey]?.[0]?.[0]);
    }
  };

  useEffect(() => {
    let { start_time, end_time, kind, type, language } = filterValue || {};
    setTimeValue([start_time, end_time]);
    setDateType(dateToMap[type as 'Day']);
    // console.log('3');
    language && setLanguageChoose(language);
    setKind(kind);
  }, [filterValue]);

  useEffect(() => {
    // console.log('2');
    setLanguageChoose(languageFilterOptions?.[0]?.[0]);
  }, [languageFilterOptions]);

  useEffect(() => {
    const { language, type, kind } = filterOptions || {};
    const newKind = kind?.[0] || '1';

    const initType = type?.[newKind]?.[0] || '1';

    const typeOptions = type?.[newKind]?.map?.(
      (item: number) => timePickerTypes[item],
    ) || ['date'];
    setTimePickerOptions(typeOptions);
    setLanguageMap(language?.[newKind]);
    setLanguageKey(initType);
    // console.log('1');
    setLanguageChoose(language?.[newKind]?.[initType]?.[0]?.[0]);
  }, [filterOptions]);

  useEffect(() => {
    const { language, type } = filterOptions;
    const newKind = kind || '1';

    const initType = type?.[newKind]?.[0] || '1';

    const typeOptions = type?.[newKind]?.map?.(
      (item: number) => timePickerTypes[item],
    ) || ['date'];
    setTimePickerOptions(typeOptions);
    setLanguageMap(language?.[newKind]);
    setLanguageKey(initType);
    // console.log('5');
    languageChoose &&
      setLanguageChoose(language?.[newKind]?.[initType]?.[0]?.[0]);
  }, [kind]);

  useEffect(() => {
    const deleteKeys: string | undefined = undefined;
    const dateValue = formatTimeToServer(timeValue, dateType as any);

    const result: DateValueType = {
      start_time: dateValue[0],
      end_time: dateValue[1],
      date_type: dateType,
    };

    if (dateTypeMap[dateType]) {
      setLanguageKey(dateTypeMap[dateType]);
    }

    onChange?.('data', commonBackInfo(result, { date: result }), deleteKeys);
  }, [timeValue, dateType]);

  return (
    <div className="dbo-gpt-select-wrapper">
      <TimePicker
        dateTypeInfo={[dateType, changeDateType]}
        dateTypeList={timePickerOptions}
        lang={lang}
        noLimitation
        gameInfo={otherProps.gameInfo}
        startOfTime={filterOptions}
        timeValueInfo={[timeValue, setTimeValue]}
        rangePickerDefaultValue={rangePickerDefaultValue}
        showShortcut={showShortcut}
        useNewsTypes={false}
      />
      <GPTLanguageSelect
        filterOptions={languageFilterOptions}
        lang={lang}
        {...otherProps}
        defaultValue={languageChoose}
        setLanguageChoose={setLanguageChoose}
        languageChoose={languageChoose}
        onChange={onChange}
      ></GPTLanguageSelect>
    </div>
  );
}
